import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { NotificationService } from '../../../common/notification.service/notification.service';

import { AuthService } from '../../../services/auth.service';
import { FormDescriptorWithIcon, ManualCreateService } from '../../dataentry/manualcreate/manualcreate.service';

import * as _ from 'underscore';
import { OrganizationModel } from '../../organization/model/organization.model';
import { OrganizationService } from '../../organization/organization.service';
import { View } from '../../../common/model/view';
import { Severity } from '../../../common/notification.service/notification.model';

@Component({
  selector: 'app-dashboard-dataentry-manualcreate',
  styleUrls: ['./manualcreate.component.sass'],
  templateUrl: './manualcreate.component.pug'
})
export class DashboardDataEntryManualCreateComponent implements OnInit {
  @Input() config: any;

  organizations: OrganizationModel[] = [];
  forms: FormDescriptorWithIcon[] = [];
  organizationId: string;
  formId: string;

  constructor(
    private bffService: ManualCreateService,
    private orgService: OrganizationService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private notificationService: NotificationService,
    private authService: AuthService,
  ) {
    const v = new View();
    v.addFilter('Deleted', 'false');
    orgService.getOrganizations(v).then(result => {
      this.organizations = result.value;

      this.config = this.config || {};
      this.config.dataentrymanualcreate = this.config.dataentrymanualcreate || {};
      if (this.config.dataentrymanualcreate.organizationId)
      {
        const org = this.organizations.find(org => org.id == this.config.dataentrymanualcreate.organizationId);
        if (org) {
          this.organizationId = this.config.dataentrymanualcreate.organizationId;
          this.selectOrganization();
        }
      }
    });
  }

  public ngOnInit(): void {

  }

  async selectOrganization() {
    this.config.dataentrymanualcreate.organizationId = this.organizationId;

    this.bffService.GetForms(this.organizationId).then( items => {
      this.forms.length = 0;
      this.forms.push(... items);

      if (this.forms.length == 1) {
        this.formId = this.forms[0].id;
      }
      else
      {
        this.formId = undefined;
      }
    });
  }

  async create(formId: string) {
    await this.bffService.CreateDataEntry(this.organizationId, formId).then(deid => {
      this.notificationService.showNotification('Az adatszolgáltatás létrehozása sikerült!', Severity.success);
      this.router.navigate(['/dataentry/opened/render', deid]);    
    }).catch(e => {
      this.notificationService.showNotification(e.error, Severity.error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dataentry/manualcreate.component.ts